import Sticky from 'sticky-js'

class Entete {
  init () {
    function handleResize () {
      if ($(window).width() >= 768) {
        const stickyCompteur = new Sticky('.wp-block-en-tete .compteur')
      }
    }

    handleResize()
    $(window).on('resize', handleResize)
  }
}

export default Entete
